
export default {
  code: "th",
  buttonText: {
    prev: "ย้อน",
    next: "ถัดไป",
    today: "วันนี้",
    month: "เดือน",
    week: "สัปดาห์",
    day: "วัน",
    list: "แผนงาน"
  },
  allDayText: "ตลอดวัน",
  eventLimitText: "เพิ่มเติม",
  noEventsMessage: "ไม่มีกิจกรรมที่จะแสดง"
};
